// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EwmV","controls":"styles_controls__22fYq","charLimit":"styles_charLimit__9jmU4","input":"styles_input__3vQCI","send":"styles_send__3b3bb"};